/** Estado del flujo OTP en curso (persiste en recarga de página). */
const PENDING_OTP_KEY = "pendingSubscriberOtp";
const MAX_AGE_MS = 30 * 60 * 1000;

export function savePendingOtpSession(payload) {
  if (!payload?.user?.clientId && !payload?.user?.ClientId) {
    return;
  }
  try {
    sessionStorage.setItem(
      PENDING_OTP_KEY,
      JSON.stringify({
        ...payload,
        savedAt: Date.now(),
      })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadPendingOtpSession() {
  try {
    const raw = sessionStorage.getItem(PENDING_OTP_KEY);
    if (!raw) {
      return null;
    }
    const data = JSON.parse(raw);
    if (!data?.savedAt || Date.now() - data.savedAt > MAX_AGE_MS) {
      clearPendingOtpSession();
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearPendingOtpSession() {
  try {
    sessionStorage.removeItem(PENDING_OTP_KEY);
  } catch {
    /* ignore */
  }
}
